import Vue from 'vue'
import {
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tabs,
  TabPane,
  Input,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Button,
  ButtonGroup,
  Form,
  FormItem,
  Icon,
  Row,
  Col,
  Loading,
  Popover,
  MessageBox,
  Message,
  Notification,
  Table,
  TableColumn,
  Progress,
  Select,
  Option,
  DatePicker,
} from 'element-ui'

const components = [
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tabs,
  TabPane,
  Input,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Button,
  ButtonGroup,
  Form,
  FormItem,
  DatePicker,
  Icon,
  Row,
  Col,
  Popover,
  Table,
  TableColumn,
  Option,
  Progress,
  Select,
]

components.forEach(component => Vue.use(component))

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
